// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  InputNumber,
  DatePicker,
  Image,
  Upload
} from '@arco-design/web-react';
import { post, get } from '../requestNew';
import dayjs from 'dayjs';

import './index.scss';
import { baseUrl } from '../utils';
import type { GameItem } from './types';

const FormItem = Form.Item;
const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

function GameManagement() {
  const [form] = Form.useForm<GameItem>();
  const [formSearch] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<GameItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [gameSessionList, setGameSessionList] = useState<{label: string, value: string}[]>([]);
  const formRef = useRef<any>({});
  const [isShowChecked, setIsShowChecked] = useState(false);
  // const URL_UPLOAD = baseUrl + '/sysMenu/uploadImage';
  const URL_UPLOAD = baseUrl + '/common/uploadFile';

  // 比赛类型选项
  const gameTypeOptions = [
    { label: '常规赛', value: 1 },
    { label: '半年赛', value: 2 },
    { label: '年赛', value: 3 },
    { label: '量化', value: 4 }
  ];

  // 报名状态选项
  const gameStatusOptions = [
    { label: '报名中', value: 1 },
    { label: '进行中', value: 2 },
    { label: '待开始', value: 3 },
    { label: '已结束', value: 0 }
  ];

  // 处理首页报名开关变更
  const isShowChange = (val: boolean, record: GameItem) => {
    const swFlag = val ? 1 : 0;
    setLoading(true);

    post(`/gameConfig/update`, { ...record, isShow: swFlag })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 重置筛选条件
  const handleReset = () => {
    formSearch.resetFields();
    setPageNum(1);
    setPageSize(10);
    getList(true);
  };

  // 表格列配置
  const columns: TableColumnProps[] = [
    {
      title: '序号',
      width: 50,
      render: (_, record, i) => i + 1
    },
    {
      title: '赛季名称',
      dataIndex: 'gameSessionName',
      width: 120
    },
    {
      title: '比赛编码',
      dataIndex: 'gameSession',
      width: 100
    },
    {
      title: '比赛类型',
      dataIndex: 'gameType',
      width: 100,
      render: (text) => {
        const typeMap: Record<number, string> = {
          1: '常规赛',
          2: '半年赛',
          3: '年赛',
          4: '量化'
        };
        return typeMap[text] || text;
      }
    },
    {
      title: '报名开始时间',
      dataIndex: 'registerStartTime',
      width: 150,
      render: text => text ? dayjs(text).format('YYYY-MM-DD') : ''
    },
    {
      title: '报名结束时间',
      dataIndex: 'registerEndTime',
      width: 150,
      render: text => text ? dayjs(text).format('YYYY-MM-DD') : ''
    },
    {
      title: '比赛开始时间',
      dataIndex: 'gameStartTime',
      width: 150,
      render: text => text ? dayjs(text).format('YYYY-MM-DD') : ''
    },
    {
      title: '比赛结束时间',
      dataIndex: 'gameEndTime',
      width: 150,
      render: text => text ? dayjs(text).format('YYYY-MM-DD') : ''
    },
    {
      title: '报名费用',
      dataIndex: 'gameMoney',
      width: 100,
      render: text => text || '0'
    },
    {
      title: '比赛报名状态',
      dataIndex: 'gameStatus',
      width: 100,
      render: (text) => {
        const statusMap: Record<string, string> = {
          '1': <span style={{ color: '#165DFF' }}>报名中</span>,
          '2': <span style={{ color: '#00B42A' }}>进行中</span>,
          '3': <span style={{ color: '#FF7D00' }}>待开始</span>,
          '0': <span style={{ color: '#86909C' }}>已结束</span>
        };
        return statusMap[text] || text;
      }
    },
    {
      title: '首页报名开关',
      dataIndex: 'isShow',
      width: 120,
      render: (text, record) => <Switch checked={text === 1} onChange={val => isShowChange(val, record)} />
    },
    {
      title: '首页报名图',
      dataIndex: 'gameUrl',
      width: 100,
      render: (text) => (text && text.indexOf('http') === 0) ? (
        <Image
          src={text}
          width={50}
          height={50}
          fit="cover"
          preview={true}
          style={{ borderRadius: 4 }}
        />
      ) : '-'
    },
    {
      title: '报名人数',
      dataIndex: 'gameNum',
      width: 80,
      render: text => text || '0'
    },
    {
      title: '总资产',
      dataIndex: 'totalAssets',
      width: 80,
      render: text => text || '0'
    },
    {
      title: '标题',
      dataIndex: 'title',
      width: 120,
      render: text => text || ''
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 120,
      render: (_, record: GameItem) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)} loading={loading}>
            编辑
          </Button>
          <Popconfirm focusLock title="提示" content="是否确认删除?" onOk={() => del(record)}>
            <Button className="btn" type="text" status="danger" loading={loading}>
              删除
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  // 获取赛季列表
  const getGameSessionList = () => {
    get('/gameConfig/getGameSessionList')
      .then((res: any) => {
        const { data } = res || {};
        if (data && Array.isArray(data)) {
          const options = data.map((item: any) => ({
            label: item, // 假设返回的数据格式直接是赛季名称字符串
            value: item
          }));
          setGameSessionList(options);
        }
      })
      .catch(() => {
        Message.error('获取赛季列表失败!');
      });
  };

  // 获取数据列表
  const getList = (reset?: boolean) => {
    setLoading(true);
    if (reset) {
      setPageNum(1);
      setPageSize(10);
    }

    const params = {
      ...formSearch.getFieldsValue(),
      pageNum,
      pageSize
    };

    get('/gameConfig/list', params)
      .then((res: any) => {
        const { list, total } = res.data || {};
        setTotal(total);
        setDataList(list || []);
      })
      .catch(() => {
        Message.error('获取数据失败!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 新增比赛
  const add = () => {
    formRef.current = {};
    setIsShowChecked(false);
    form.resetFields();
    form.setFieldsValue({
      gameUrl: '',
      isShow: false
    });
    setVisible(true);
  };

  // 删除比赛
  const del = (record: GameItem) => {
    setLoading(true);
    post(`/gameConfig/delete?id=${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 编辑比赛
  const edit = (record: GameItem) => {
    formRef.current = record;
    const isShowChecked = record.isShow === 1;
    setIsShowChecked(isShowChecked);
    form.setFieldsValue({
      ...record,
      isShow: record.isShow === 1,
      gameTeamStatus: record.gameTeamStatus === 1,
      registerTimeRange: [
        record.registerStartTime ? dayjs(record.registerStartTime) : null,
        record.registerEndTime ? dayjs(record.registerEndTime) : null
      ],
      gameTimeRange: [
        record.gameStartTime ? dayjs(record.gameStartTime) : null,
        record.gameEndTime ? dayjs(record.gameEndTime) : null
      ]
    });
    setVisible(true);
  };

  // 取消编辑
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };

  // 提交表单
  const onOk = () => {
    form.validate().then(values => {
      // 校验：如果首页报名开关打开，检查报名时间和比赛时间是否填写
      if (values.isShow) {
        if (!values.registerTimeRange || values.registerTimeRange.length !== 2 || 
            !values.gameTimeRange || values.gameTimeRange.length !== 2) {
          Message.error('首页报名开关已打开，请填写完整的报名时间和比赛时间');
          return;
        }
      }

      // 校验：比赛开始时间必须晚于报名结束时间
      if (values.registerTimeRange && values.registerTimeRange.length === 2 && 
          values.gameTimeRange && values.gameTimeRange.length === 2) {
        if (new Date(values.gameTimeRange[0]) < new Date(values.registerTimeRange[1])) {
          Message.error('比赛开始时间必须晚于报名结束时间');
          return;
        }
      }

      setLoading(true);
      const data = {
        ...formRef.current,
        ...values,
        isShow: values.isShow ? 1 : 0,
        gameTeamStatus: values.gameTeamStatus ? 1 : 0,
        registerStartTime: values.registerTimeRange && values.registerTimeRange.length === 2 
          ? dayjs(values.registerTimeRange[0]).format('YYYY-MM-DD') 
          : null,
        registerEndTime: values.registerTimeRange && values.registerTimeRange.length === 2 
          ? dayjs(values.registerTimeRange[1]).format('YYYY-MM-DD') 
          : null,
        gameStartTime: values.gameTimeRange && values.gameTimeRange.length === 2 
          ? dayjs(values.gameTimeRange[0]).format('YYYY-MM-DD') 
          : null,
        gameEndTime: values.gameTimeRange && values.gameTimeRange.length === 2 
          ? dayjs(values.gameTimeRange[1]).format('YYYY-MM-DD') 
          : null
      };
      
      // 删除临时的range字段
      delete data.registerTimeRange;
      delete data.gameTimeRange;

      const url = formRef.current.id ? `/gameConfig/update` : `/gameConfig/add`;

      post(url, data)
        .then((res: any) => {
          const { code, message } = res || {};
          if (code === 200) {
            Message.success(formRef.current.id ? '编辑成功！' : '新增成功！');
            getList();
            editCancel();
          } else {
            Message.error(message);
          }
        })
        .catch(e => {
          Message.error('网络错误!');
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  useEffect(() => {
    getGameSessionList(); // 页面初始化时获取赛季列表
    getList();
  }, [pageNum, pageSize]);

  return (
    <div className="game-management table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="赛季" field="gameSession">
            <Select style={{ width: 150 }} allowClear placeholder="请选择赛季">
              {gameSessionList.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="报名状态" field="gameStatus">
            <Select style={{ width: 120 }} allowClear placeholder="请选择">
              {gameStatusOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="报名开关" field="isShow">
            <Select style={{ width: 120 }} allowClear placeholder="请选择">
              <Option value={0}>关</Option>
              <Option value={1}>开</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={() => getList(true)} loading={loading}>
              查询
            </Button>
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={handleReset} loading={loading}>
              重置
            </Button>
          </FormItem>
          <FormItem>
            <Button className="filter-item" type="primary" onClick={add} loading={loading}>
              新增比赛
            </Button>
          </FormItem>
        </Form>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
          loading={loading}
        />
      </div>
      <Modal
        title={formRef.current.id ? '编辑比赛' : '新增比赛'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 600 }}
        confirmLoading={loading}
      >
        <Form {...formItemLayout} form={form}>

          <FormItem label="赛季名称" field="gameSessionName" rules={[{ required: true, message: '请输入赛季名称' }]}>
            <Input placeholder="请输入赛季名称" />
          </FormItem>
          <FormItem label="比赛编码" field="gameSession" rules={[{ required: true, message: '请输入比赛编码' }]}>
            <Input placeholder="请输入比赛编码" />
          </FormItem>
          <FormItem label="比赛类型" field="gameType" rules={[{ required: true, message: '请选择比赛类型' }]}>
            <Select placeholder="请选择">
              {gameTypeOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="报名banner标题" field="title">
            <Input placeholder="请输入报名banner标题" />
          </FormItem>
          <FormItem label="报名banner备注" field="content">
            <Input placeholder="请输入报名banner备注" />
          </FormItem>
          <FormItem label="首页报名图" field="gameUrl">
            <Upload
              action={URL_UPLOAD}
              headers={{
                'Authorization': `${localStorage.getItem('authToken')}`
              }}
              defaultFileList={form.getFieldValue('gameUrl') ? [{ url: form.getFieldValue('gameUrl'), uid: '-1', name: 'gameUrl' }] : []}
              onChange={(_, file) => {
                if (file?.response?.data) {
                  form.setFieldValue('gameUrl', file.response.data);
                }
              }}
              onRemove={() => {
                form.setFieldValue('gameUrl', '');
              }}
              limit={1}
              imagePreview
              listType="picture-card"
              multiple={false}
              accept="image/*"
            />
          </FormItem>
          <FormItem label="是否含粉丝团" field="gameTeamStatus" triggerPropName="checked">
            <Switch />
          </FormItem>
          <FormItem label="首页报名开关" field="isShow" triggerPropName="checked">
            <Switch onChange={(checked) => setIsShowChecked(checked)} />
          </FormItem>
          <FormItem label="比赛排序" field="orderNum">
            <InputNumber placeholder="请输入比赛排序" style={{ width: '100%' }} min={0} />
          </FormItem>
          <FormItem label="规则笔记ID" field="noteBookId">
            <InputNumber placeholder="请输入规则笔记ID" style={{ width: '100%' }} min={0} />
          </FormItem>
          <FormItem label="报名时间" field="registerTimeRange">
            <RangePicker
              placeholder={['开始时间', '结束时间']}
              style={{ width: '100%' }}
            />
          </FormItem>
          <FormItem label="比赛时间" field="gameTimeRange">
            <RangePicker
              placeholder={['开始时间', '结束时间']}
              style={{ width: '100%' }}
            />
          </FormItem>

          <FormItem label="比赛报名费" field="gameMoney">
            <InputNumber placeholder="请输入比赛报名费" style={{ width: '100%' }} min={0} />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default GameManagement;